import { render } from "./NotificationListPage.vue?vue&type=template&id=bb113de4&ts=true"
import script from "./NotificationListPage.vue?vue&type=script&lang=ts"
export * from "./NotificationListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__